import React from 'react';
import './Impressum.css';

const Legalde = () => {
  return (
    <div className="container my-5" style={{ maxWidth: 800 }}>
      <h1 className="mb-4">Allgemeine Geschäftsbedingungen (AGB)</h1>
      <p><em>Stand: Februar 2026</em></p>

      <h2 className="mt-4">1. Geltungsbereich</h2>
      <p>
        Diese Allgemeinen Geschäftsbedingungen (nachfolgend «AGB») gelten für sämtliche Bestellungen über den
        Onlineshop <a href="https://vegbox.ch" target="_blank" rel="noreferrer">www.vegbox.ch</a>,
        betrieben von der Vegbox GmbH (nachfolgend «Vegbox»). Mit der Aufgabe einer Bestellung akzeptiert
        die Kundschaft diese AGB.
      </p>
      <p>
        Das Angebot richtet sich ausschliesslich an Kundinnen und Kunden mit Wohn- oder Geschäftssitz in der Schweiz.
        Lieferungen erfolgen ausschliesslich an Adressen in der Schweiz.
      </p>

      <h2 className="mt-4">2. Angebot und Preise</h2>
      <p>
        Alle Preise im Onlineshop verstehen sich in Schweizer Franken (CHF) und sind inklusive der
        gesetzlichen Mehrwertsteuer (MwSt. 8.1%). Versandkosten werden beim Checkout separat ausgewiesen.
        Ab einem Bestellwert von CHF 80 ist der Versand kostenlos.
      </p>
      <p>
        Vegbox behält sich das Recht vor, die Preise jederzeit zu ändern. Massgebend ist jeweils der Preis
        zum Zeitpunkt der Bestellung. Offensichtliche Preisfehler stellen kein verbindliches Angebot dar.
      </p>

      <h2 className="mt-4">3. Vertragsabschluss</h2>
      <p>
        Die im Onlineshop dargestellten Produkte und Preise sind ein unverbindliches Angebot.
        Der Kaufvertrag kommt zustande, wenn die Kundschaft eine Bestellung aufgibt und eine
        Bestellbestätigung per E-Mail erhält.
      </p>

      <h2 className="mt-4">4. Zahlung</h2>
      <p>
        Die Zahlung erfolgt über die im Onlineshop angebotenen Zahlungsmittel (Kreditkarte via Stripe).
        Die Belastung erfolgt zum Zeitpunkt der Bestellung.
      </p>

      <h2 className="mt-4">5. Lieferung</h2>
      <p>
        Vegbox liefert an Adressen in der Schweiz. Das Lieferdatum und das Zeitfenster werden von der
        Kundschaft beim Checkout gewählt. Vegbox bemüht sich, die gewählte Lieferzeit einzuhalten,
        kann jedoch keine genauen Lieferzeiten garantieren.
      </p>
      <p>
        Ist die Kundschaft zum vereinbarten Lieferzeitpunkt nicht erreichbar, kann Vegbox
        zusätzliche Lieferkosten in Rechnung stellen.
      </p>

      <h2 className="mt-4">6. Widerrufsrecht / Rückgabe</h2>
      <p>
        Da es sich bei den verkauften Produkten um verderbliche Lebensmittel handelt, sind Rückgabe
        und Umtausch gemäss schweizerischem Recht ausgeschlossen. Nach Bestätigung der Bestellung
        besteht kein Widerrufsrecht.
      </p>
      <p>
        Bei mangelhafter oder falscher Lieferung muss die Kundschaft Vegbox innerhalb von 24 Stunden
        nach Erhalt benachrichtigen. Vegbox wird einen Ersatz oder eine Rückerstattung veranlassen.
      </p>

      <h2 className="mt-4">7. Gewährleistung</h2>
      <p>
        Vegbox garantiert die Frische und Qualität der Produkte zum Zeitpunkt der Lieferung.
        Aufgrund der Beschaffenheit verderblicher Waren ist die Gewährleistung auf den Zeitpunkt
        der Lieferung beschränkt. Die Kundschaft ist verpflichtet, die Waren bei Erhalt zu prüfen
        und Mängel unverzüglich zu melden.
      </p>

      <h2 className="mt-4">8. Haftung</h2>
      <p>
        Vegbox haftet nur für Schäden, die durch Vorsatz oder grobe Fahrlässigkeit verursacht werden.
        Die Haftung für leichte Fahrlässigkeit, indirekte Schäden, Folgeschäden und entgangenen
        Gewinn ist ausgeschlossen.
      </p>

      <h2 className="mt-4">9. Datenschutz</h2>
      <p>
        Der Umgang mit Personendaten ist in unserer{' '}
        <a href="/privacy-policy">Datenschutzerklärung</a> geregelt.
      </p>

      <h2 className="mt-4">10. Anwendbares Recht und Gerichtsstand</h2>
      <p>
        Es gilt schweizerisches Recht. Ausschliesslicher Gerichtsstand ist Dübendorf, Schweiz,
        unter Vorbehalt zwingender gesetzlicher Bestimmungen.
      </p>

      <h2 className="mt-4">11. Salvatorische Klausel</h2>
      <p>
        Sollten einzelne Bestimmungen dieser AGB ungültig sein oder werden, bleibt die Wirksamkeit
        der übrigen Bestimmungen davon unberührt.
      </p>

      <h2 className="mt-4">12. Kontakt</h2>
      <p>
        <strong>Vegbox GmbH</strong><br />
        Dietlikonstrasse 29, 8600 Dübendorf<br />
        Telefon: +41 78 222 42 36<br />
        E-Mail: <a href="mailto:vegboxgmbh@gmail.com">vegboxgmbh@gmail.com</a><br />
        Website: <a href="https://vegbox.ch" target="_blank" rel="noreferrer">www.vegbox.ch</a>
      </p>

      <p className="mt-4"><em>© 2026 Vegbox GmbH — Alle Rechte vorbehalten</em></p>
    </div>
  );
};

export default Legalde;
